/**
 * @export
 * @param {number} step
 * @returns
 */
export function toggleMembershipStep(step) {
    return {
        type: "TOGGLE_MEMBERSHIP_STEP",
        step
    };
}

export function registerValuesMembership(object) {
    return {
        type: "MEMBERSHIP_VALUES",
        object
    }
}

export function registerUnitMembership(object) {
    return {
        type: "MEMBERSHIP_UNIT",
        object
    }
}

/**
 * @export
 * @returns
 */
export function resetStateMembership() {
    return {
        type: "RESET_STATE_MEMBERSHIP"
    }
}
